import service from '../service.js'

export default{

    uploadDisplayPicture(emp_key, img)
    {
        return service.post('display-picture',{
            emp_key : emp_key,
            img     : img
        })
    },
}